export const userDataAction = {
    userDataRedux
};

function userDataRedux(data,type) {
        console.log("data:",data,type);
       return dispatch => {dispatch(request(data));
        function request(data) { return { type: type,data } }
       }
}